export default "__VITE_ASSET__39542472__"